import Alpine from 'alpinejs';

/* global frontend_ajax, selfAssessmentPluginData, __ctm */

Alpine.data('formHandler', () => ({
    responseMessage: '',
    submitted: false,
    submitFail: false,
    submitting: false,

    init() {
        // Retire only this form's legacy personal-data keys.
        try {
            ['user_name', 'user_email', 'user_saved', 'user_age', 'user_gender', 'user_postcode']
                .forEach(key => localStorage.removeItem(key));
        } catch (error) {
            // Blocked browser storage must not prevent form submission.
        }
    },

    sendResults(button, email) {
        if (typeof selfAssessmentPluginData === 'undefined'
            || !selfAssessmentPluginData.resultId || !selfAssessmentPluginData.emailNonce) {
            this.submitFail = true;
            this.responseMessage = 'Please reload the page and complete the assessment before requesting an email.';
            this.updateButtonLoadingState(button, false, 'Try again');
            return Promise.resolve(false);
        }

        this.updateButtonLoadingState(button, true, 'Sending...');
        return Promise.resolve($.ajax({
            url: frontend_ajax.ajaxurl,
            method: 'POST',
            dataType: 'json',
            data: {
                _ajax_nonce: selfAssessmentPluginData.emailNonce,
                action: 'self_assessment_email_result',
                email,
                result_id: selfAssessmentPluginData.resultId,
            },
        })).then(result => {
            const sent = Boolean(result && result.success === true);
            this.submitted = sent;
            this.submitFail = !sent;
            this.responseMessage = (result && result.message) || (sent
                ? 'Your results email has been sent.'
                : 'We couldn’t send your results email. Your results are still available on this page. Please try again later.');
            this.updateButtonLoadingState(button, false, sent ? 'Email sent!' : 'Try again');
            return sent;
        }).catch(error => {
            this.submitted = false;
            this.submitFail = true;
            this.responseMessage = (error && error.responseJSON && error.responseJSON.message)
                || 'We couldn’t confirm that your results email was sent. Your results are still available on this page. Please try again later.';
            this.updateButtonLoadingState(button, false, 'Try again');
            return false;
        });
    },

    submitForm(event) {
        event.preventDefault();
        if (this.submitting) {
            return;
        }

        const form = event.target;
        const button = form.querySelector('[type="submit"]');
        this.submitting = true;
        this.submitted = false;
        this.submitFail = false;
        this.responseMessage = '';
        this.updateButtonLoadingState(button, true);

        let payload;
        return Promise.resolve().then(() => {
            const data = Object.fromEntries(new FormData(form).entries());
            if (typeof __ctm !== 'undefined' && __ctm.config && __ctm.config.sid) {
                data.visitor_id = __ctm.config.sid;
            }

            payload = {
                form_id: form.id || null,
                form_name: form.name || null,
                form_data: data,
            };
            return fetch('/wp-json/spp-sage-form/v1/submit-form', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            }).then(response => response.json().then(result => {
                if (!response.ok || !result.success) {
                    throw new Error('Form submission failed.');
                }
                return result;
            }));
        }).then(result => {
            if (form.name === 'js_self_assessment_start_form') {
                // Record demographics from this successful submission, even if email fails.
                this.$dispatch('form-submit', payload);
                this.responseMessage = 'Sending your results email…';
                return this.sendResults(button, payload.form_data.EMAIL);
            }
            this.submitted = true;
            this.responseMessage = result.message;
            this.updateButtonLoadingState(button, false, 'Success!');
            return true;
        }).then(sent => {
            if (!sent) {
                return;
            }
            // Keep all fields and custom labels intact until the email succeeds.
            form.reset();
            if (form.name === 'js_self_assessment_start_form') {
                const store = Alpine.store('self_assessment_modal');
                store.state.genderLabel = 'Gender';
                store.state.typeLabel = "I'm assessing...";
            } else {
                this.$dispatch('form-submit', payload);
            }

            setTimeout(() => this.$dispatch('close-modal'), 0);
        }).catch(() => {
            this.submitFail = true;
            this.responseMessage = 'There was an error submitting the form.';
            this.updateButtonLoadingState(button, false);
        }).finally(() => {
            this.submitting = false;
            button.disabled = false;
        });
    },

    updateButtonLoadingState(button, isLoading, text = '') {
        button.disabled = isLoading;
        if (isLoading) {
            button.classList.add('loading');
            button.textContent = text || 'Submitting...';
        } else {
            button.classList.remove('loading');
            button.textContent = text || 'Submit';
            if (button.className === '') {
                button.removeAttribute('class');
            }
        }
    },
}));
